import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

import './Components/Bootstrap/xs.css';
import './Components/Bootstrap/sm.css';
import './Components/Bootstrap/md.css';
import './Components/Bootstrap/lg.css';
import './Components/Bootstrap/xl.css';
import './Components/Bootstrap/xxl.css';

import 'bootstrap/dist/css/bootstrap.min.css';


const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
